// extracted by mini-css-extract-plugin
export default {"loader":"TOI-6","load6":"U6HFx","medium":"mvMtM","mini":"lJM4n"};